<template>
  <AppDialog
    :is-open="isDialogOpened"
    :ok-text="$t('project.nda.dialogs.NdaAddedSignDialog.confirmText').toString()"
    :cancel-text="$t('project.nda.dialogs.NdaAddedSignDialog.cancelText').toString()"
    size="l"
    @ok="signNda"
    @cancel="$router.push('/')"
  >
    <template #title>
      {{ $t('project.nda.dialogs.NdaAddedSignDialog.title') }}
    </template>
    <template #body>
      <p>{{ $t('project.nda.dialogs.NdaAddedSignDialog.confirmedAction') }}</p>
      <p>{{ $t('project.nda.dialogs.NdaAddedSignDialog.actionIncentive') }}</p>
    </template>
  </AppDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'
import { NDA_SIGNING_VIEW_ROUTE_NAME } from '@/router'

export default defineComponent({
  name: 'NdaAddedSignDialog',
  components: {
    AppDialog,
  },
  mixins: [dialogMixin],
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  methods: {
    signNda () {
      this.$router.push({
        name: NDA_SIGNING_VIEW_ROUTE_NAME,
        params: {
          mnemo: this.mnemo,
        },
      })
    },
  },
})
</script>
